module.exports = __webpack_public_path__ + "img/75728.6ec835ac.svg";